import { Price } from './Price.js';
import { Products } from './Products.js';

class Shipments {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.price = new Price(apiClient);
    this.products = new Products(apiClient);
  }
}

export { Shipments };
//# sourceMappingURL=Shipments.js.map
